import { useQuery } from 'convex/react';
import { api } from '../convex/_generated/api';
import { useAuthData } from './useAuthData';

export function useLoggedInUserPointsForRestaurant(selectedRestaurant) {
    const { authData } = useAuthData();
    
    // Get user points for this restaurant
    const userPoints = useQuery(
        api.users.getUserPointsForRestaurant,
        authData.privyDid && selectedRestaurant?._id 
            ? { 
                privyDid: authData.privyDid, 
                restaurantId: selectedRestaurant._id 
              } 
            : "skip"
    ) || 0;

    return userPoints;
}